import { useMemo, useSyncExternalStore } from "react";
import { subscriptionStore } from "./index";
import type {
  Subscription,
  SubscriptionStatus,
  SubscriptionStore,
} from "./types";

function getSnapshot(): Subscription[] {
  return subscriptionStore.list();
}

const SERVER_SNAPSHOT: Subscription[] = [];
function getServerSnapshot(): Subscription[] {
  return SERVER_SNAPSHOT;
}

function subscribe(listener: () => void): () => void {
  return subscriptionStore.subscribe(listener);
}

export interface UseSubscriptionsFilter {
  status?: SubscriptionStatus[];
}

export interface UseSubscriptionsResult {
  subscriptions: Subscription[];
  add: SubscriptionStore["add"];
  update: SubscriptionStore["update"];
  remove: SubscriptionStore["remove"];
  getById(id: string): Subscription | undefined;
}

export function useSubscriptions(
  filter?: UseSubscriptionsFilter,
): UseSubscriptionsResult {
  const all = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const statusKey = filter?.status?.slice().sort().join("|") ?? "";

  const subscriptions = useMemo(() => {
    if (!filter?.status) return all;
    const allowed = new Set(filter.status);
    return all.filter((s) => allowed.has(s.status));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [all, statusKey]);

  const getById = useMemo(
    () => (id: string) => all.find((s) => s.id === id),
    [all],
  );

  return {
    subscriptions,
    add: subscriptionStore.add.bind(subscriptionStore),
    update: subscriptionStore.update.bind(subscriptionStore),
    remove: subscriptionStore.remove.bind(subscriptionStore),
    getById,
  };
}
